export const isRyanairLegs = (legs) => {
    return !!legs?.every((leg) => {
        return (leg.flightInfo.carrierInfo?.marketingCarrier === "RK" || leg.flightInfo.carrierInfo?.marketingCarrier === "FR");
    });
};
export const isRyanairSegments = (segments) => {
    return !!segments?.every((segment) => isRyanairLegs(segment.legs));
};
export const isRyanairFlight = (order) => {
    return isRyanairSegments(order.airOrder.flightSegments);
};
